import React from "react"
import Layout from "../components/layout"
import FBVideo from "../components/fb-video"

export default () => 
    <Layout>
        <div>Hello world!</div>
        <FBVideo url="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fjimmie.simpson%2Fvideos%2F10215886704305359%2F" />
    </Layout>
